import { toast } from "sonner";
import axiosInstance from "../../utility/axios";
import { AppDispatch } from "../../store/store";
import { getErrorMessage } from "../apiError";
import {
  disableCategoryLoading,
  setLoadingCategoryId,
  setCategoryLoading,
  setCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from "../../store/slices/category";
import { ICategoryResponse } from "../../store/types/category";

const categoryEndpoint = "/blog/api/v1/admin";

export const get_categories = async (
  dispatch: AppDispatch,
  offset: number = 0,
  limit: number = 20,
) => {
  dispatch(setCategoryLoading());
  try {
    const response = await axiosInstance.get<ICategoryResponse>(
      `${categoryEndpoint}/categories`,
      { params: { offset, limit } },
    );
    dispatch(setCategories(response.data.data));
    return true;
  } catch (err) {
    toast.error(getErrorMessage(err, "Failed to load categories"));
    return false;
  } finally {
    dispatch(disableCategoryLoading());
  }
};

export const get_category = async (dispatch: AppDispatch, id: number) => {
  dispatch(setCategoryLoading());
  try {
    const response = await axiosInstance.get(
      `${categoryEndpoint}/categories/${id}`,
    );

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to load category");
    }
    return true;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to load category"));
    return false;
  } finally {
    dispatch(disableCategoryLoading());
  }
};

export const create_category = async (dispatch: AppDispatch, name: string) => {
  dispatch(setCategoryLoading());
  try {
    const response = await axiosInstance.post(
      `${categoryEndpoint}/categories`,
      { name },
    );
    dispatch(createCategory(response.data.data));
    toast.success(response.data.message);
    return true;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to create category"));
    return false;
  } finally {
    dispatch(disableCategoryLoading());
  }
};

export const update_category = async (
  dispatch: AppDispatch,
  id: number,
  name: string,
) => {
  dispatch(setCategoryLoading());
  try {
    const response = await axiosInstance.patch(
      `${categoryEndpoint}/categories/${id}`,
      { id, name },
    );

    dispatch(updateCategory(response.data.data));
    toast.success(response.data.message);
    return true;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to update category"));
    return false;
  } finally {
    dispatch(disableCategoryLoading());
  }
};

export const delete_category = async (dispatch: AppDispatch, id: number) => {
  dispatch(setLoadingCategoryId(id));
  try {
    const response = await axiosInstance.delete(
      `${categoryEndpoint}/categories/${id}`,
    );
    dispatch(deleteCategory(id));
    toast.success(response.data.message);
    return true;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to delete category"));
    return false;
  } finally {
    dispatch(setLoadingCategoryId(null));
  }
};
